/* eslint-disable */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import cookie from "vue-cookies";
import Vuex from "vuex";
import notifications from 'vue-notification';
import * as VueGoogleMaps from "vue2-google-maps";
import './assets/css/common.css';

Vue.config.productionTip = false;

Vue.use(vuetify);
Vue.use(cookie);
Vue.use(notifications);
Vue.use(VueGoogleMaps,{
  load:{
    key:process.env.VUE_APP_GOOGLE_MAP_KEY,
    libraries:"places"
  }
})

Vue.$cookies.config("7d");

// const jwt=Vue.$cookies.get('jwt');

let headers={
  'Content-Type':'multipart/form-data',
  'Accept':'*/*',
  'Authorization':""
}

Vue.prototype.$http=axios.create({
  baseURL:process.env.VUE_APP_API_URL+'v1',
  headers:headers
});


Vue.prototype.$http.interceptors.request.use((config)=>{
  let jwt = Vue.$cookies.get('jwt');
  if(jwt){
    let authorization = jwt.token_type+' '+jwt.access_token;
    config.headers.Authorization=authorization;
  }
  return config;
},(error)=>{

})

Vue.prototype.$http.interceptors.response.use((response)=>{
  return response
},
(error)=>{
  let response = error.response
  if(response.status===401){
    router.push("/");
  }else if(response.status===500 || response.status===404){
    Vue.notify({
      group:"error",
      title:"Error Notification",
      text:"Ops, terjadi kesalahan pada server"
    })
  }else if(response.status===422){

    Vue.notify({
      group:"error",
      title:"Validation Error",
      text:response.data.data
    })
  }

  return error;
})

Vuex.Store.prototype.$http=Vue.prototype.$http;

Vue.prototype.$loading = false;

Vue.prototype.$api=function(uri){
  return process.env.VUE_APP_API_URL+uri
}

Vue.prototype.$base_url=function(uri){
  return process.env.VUE_APP_URL+uri
}

/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
      return next()
  }
  const middleware = to.meta.middleware

  const context = {
      to,
      from,
      next,
      store
  }
  return middleware[0]({
      ...context
  })
})

Vue.directive('focus', {
  inserted: function (el) {
      el.getElementsByTagName("input")[0].focus()
  }
})

new Vue({
  router,
  store,
  vuetify,
  axios,
  notifications,
  VueGoogleMaps,
  icons: {
    iconfont: 'md',
  },
  render: h => h(App)
}).$mount("#app");

export default Vue;